import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Layout from './Layout';
import Contact from './pages/Contact';
import About from './pages/About';
import Location from './pages/Location';
import Photos from './pages/Photos';
import Reviews from './pages/Reviews';
import Availability from './pages/Availability';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/location' element={<Location />} />
          <Route path='/photos' element={<Photos />} />
          <Route path='/reviews' element={<Reviews />} />
          <Route path='/availability' element={<Availability />} />
          <Route path='/contact' element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
